import { ActionTypes } from './actions/types';
import { reducerObj }  from './types';

const initialState: reducerObj = {
  userId:         '',
  userLogedIn:    '',
  quizName:       '',
  formSubmission: -1
};

const reducer = (state = initialState, action: ActionTypes) => {

  switch (action.type) {


//SET_USER_INFO         -      -      -      -      -      -      -      -      -      -      -      -


    case 'SET_USER_INFO':
    {
       const { userLogedIn, userId } = action.payload;
       return {
         ...state,
         userId: userId,
         userLogedIn: userLogedIn
       }
    }

    


//SET_QUIZ_INFO         -      -      -      -      -      -      -      -      -      -      -      -


    case 'SET_QUIZ_INFO':
    {
       const quizName = action.payload;

       return {
         ...state,
         quizName: quizName
       }
    }

    


//SUBMIT_FORM         -      -      -      -      -      -      -      -      -      -      -      -


case 'SUBMIT_FORM':  
  {
     return {
       ...state,
       formSubmission: action.payload
     }
  }


//  -      -      -      -      -      -      -      -      -      -      -      -


    default: return state;
  }
};

export type reducerType = ReturnType<typeof reducer>;

export { reducer };
